<template>
  <div class="pkgp">
    <div class="renew-tips" v-if="disableDate != 'disable' && (disableDate || isPkgBought)">尊贵的VIP用户，您的VIP将于{{ disableDate || packageDetail.disableDate | dateFormat }}到期<a @click="buyProduct">续费VIP</a></div>
    <div class="renew-tips" v-if="disableDate == 'disable'">尊贵的VIP用户，您的VIP课程包已到期哦<a @click="buyProduct">续费VIP</a></div>
    <img src="/images/goods/pkgp/pm0.png" alt="" />
    <img src="/images/goods/pkgp/pm1.png" alt="" />
    <img src="/images/goods/pkgp/pm2.png" alt="" />
    <img src="/images/goods/pkgp/pm3.png" alt="" />
    <img src="/images/goods/pkgp/pm4.png" alt="" />
    <pkg-button-bar v-if="packageDetail" :buyState="isPkgBought" mode="parent-pkg" :disableDate="disableDate" @bottomBarHandler="bottomBarHandler">
      <template v-slot:buy>
        <div v-html="isPkgBought || disableDate == 'disable' ? `立即续费 <span class='ico'>¥</span>${packageDetail.price || 0}<span style='font-size:14px;'>/年</span>` : `立即入学 <span class='ico'>¥</span>${packageDetail.price || 0}<span style='font-size:14px;'>/年</span>`"></div>
      </template>
    </pkg-button-bar>
    <cus-share v-show="shareTipsShow" @cancel="shareTipsShow = false"></cus-share>
    <member-guide v-model="guideShow" @confirm="confirmHReaderTips" :isMember="isPkgBought"></member-guide>
  </div>
</template>

<script>
import { find, isEmpty } from 'lodash'
import { dateFormat } from '@/utils/filter'
import { PkgButtonBar, MemberGuide } from '@/components/goods'
import { mapGetters } from 'vuex'
// import Browser from '@/utils/browser'

export default {
  components: { PkgButtonBar, MemberGuide },
  filters: { dateFormat },
  data() {
    return {
      memberFreeList: [],
      memberChargeList: [],
      packageDetail: {},
      shareTipsShow: false,
      guideShow: false,
      pkgBuyStatus: false,
      disableDate: null,
    }
  },
  created() {
    this.$api
      .payment_v1_goods_member_package_list_get({
        params: {
          channel: 1,
        },
      })
      .then((list) => {
        if (list) {
          this.packageDetail = find(list, { type: 1 }) || {}
        }
      })
  },
  watch: {
    uid: {
      immediate: true,
      handler: function(uid) {
        if (uid) {
          this.$api
            .resource_v1_user_member_package_list({
              params: {
                //父母礼包
                type: 1,
                channel: 1,
                uid: this.uid,
              },
            })
            .then((list) => {
              if (list.code == 4002) {
                this.disableDate = 'disable'
              } else if (list) {
                this.disableDate = find(list, { type: 0 }) && find(list, { type: 0 }).disableDate
              }
            })
        }
      },
    },
  },
  methods: {
    login() {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'login',
        })
      } else {
        this.$router.push('/account/login-bySMS')
      }
    },
    shareToInvite() {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/toInvite', {
          params: {
            goodsNum: this.packageDetail.goodsNum,
          },
        })
      } else {
        this.shareTipsShow = true
      }
    },
    buyProduct() {
      // if (this.isNative) {
      //   this.$store.dispatch('externalInterface/productBuy', {
      //     type: 'package',
      //     goodsNum: this.packageDetail.goodsNum,
      //   })
      // } else {
      if (!this.isLogin) {
        this.login()
        return
      }
      this.$router.push(`/goods/checkoutPkg/${this.packageDetail.goodsNum}`)
      // }
    },
    bottomBarHandler(flag) {
      let handler = {
        login: this.login,
        share: this.shareToInvite,
        buy: this.buyProduct,
        navigate: () => {
          if (this.isPkgBought) {
            if (this.isNative) {
              this.$store.dispatch('externalInterface/navigateTo', {
                name: 'parentZone',
                params: {
                  id: 4,
                },
              })
            } else {
              location.href = this.downloadPath
            }
          }
        },
      }
      handler[flag]()
    },
    confirmHReaderTips() {
      this.guideShow = false
    },
  },
  computed: {
    ...mapGetters({
      // headers: 'auth/headers',
      isNative: 'externalInterface/isNative',
      downloadPath: 'externalInterface/downloadApp',
      isWeak: 'auth/isWeak',
      uid: 'auth/uid',
      contextInfo: 'auth/contextInfo',
      isLogin: 'auth/isLogin',
    }),
    isPkgBought() {
      return this.packageDetail.status === 1
    },
  },
}
</script>

<style scoped>
.pkgp {
  width: 100vw;
  padding-bottom: 52px;
}
.pkgp > img {
  display: block;
  width: 100vw;
}
.renew-tips {
  padding: 0 16px;
  height: 40px;
  line-height: 40px;
  color: #ff6886;
  font-size: 13px;
  display: flex;
  position: fixed;
  top: 0;
  width: 100vw;
  vertical-align: middle;
  background: #fff1e2;
  z-index: 99999;
}
.renew-tips a {
  display: inline-block;
  font-size: 13px;
  line-height: 23px;
  color: #fff;
  height: 28px;
  line-height: 28px;
  width: 65px;
  text-align: center;
  margin: 6px 0 0 auto;
  border-radius: 4px;
  background: linear-gradient(#ff6886, #ff4b6f);
}
</style>
